import React from 'react';
import VideoPlayer from '../components/VideoPlayer';

interface VideosProps {
  isPartyModeActive?: boolean;
}

const Videos: React.FC<VideosProps> = ({ isPartyModeActive = false }) => {

  return (
    <>
    <section className="content-section">
      <div className="container">
        <h1 className="section-title">Videos</h1>
        <VideoPlayer isPartyModeActive={isPartyModeActive} />
      </div>
    </section>
    </>
  );
};

export default Videos;
